import * as tslib_1 from "tslib";
import { GetPendingUserMarketDataEntitlementDetailsUrl, GetPendingUserMarketDataEntitlementsUrl, GetUserMarketDataEntitlementsUrl, SubmitMktDataUserProfileReviewUrl, } from '../constants';
import { RequestHeaders } from './utilities';
export const Entitlements = (api) => ({
    getPendingUserMarketDataEntitlements: (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api.authenticated().get(GetPendingUserMarketDataEntitlementsUrl, request, RequestHeaders);
    }),
    submitMktDataUserProfileReview: (data) => api.authenticated().post(SubmitMktDataUserProfileReviewUrl, data, RequestHeaders),
    getUserMarketDataEntitlements: () => api.authenticated().get(GetUserMarketDataEntitlementsUrl, {}, RequestHeaders),
    getPendingUserMarketDataEntitlementDetails: (entitlementId) => api
        .authenticated()
        .get(GetPendingUserMarketDataEntitlementDetailsUrl, { pendingId: entitlementId }, RequestHeaders),
});
//# sourceMappingURL=entitlements.js.map